export default {
  guideList: null,
}
